import React, { useState, useEffect } from 'react'

import { PatientDetails } from '../../components/common/patientDetails';

import {
    deleteAllPatientList,
    filterPatientsByPharmacistSign
} from '../../services/slices/supervisor/patientWithoutPharmacistSign';

import {
    ErrorMessage,
    SuccessMessage
} from '../../components/common/AllConfirmationMessages';

import { ErrorMessages } from '../../components/error/errorMessages';

import { PendingPharmacistSignRxData } from '../../components/common/dispenseRxData';
import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';
import { fetchPatientListWithoutPharmacistSign } from '../../services/apis/supervisor/patientWithoutPharmacistSign';

import { useCustomStates } from '../../hooks/useCustomStates';
import { useAuthSelector } from '../../services/selectors/authSelector';
import { UpdatePharmacistSignature } from '../../services/apis/supervisor/updatePharmacistSign';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';

import * as Loading from '../../components/common/loader'
import * as routeNames from '../../routes/routeName'

const PendingPharmacistSignatures = () => {

    const { pharmacyId } = useAuthSelector()
    const { PatientListWithoutPharmacistSignResponse } = useSuperVisorSelector()
    const patientList = PatientListWithoutPharmacistSignResponse?.data

    const { openIndex, setOpenIndex, setPharmacistSignature, pharmacistSignature,
        loading, setLoading, showPharmacistSignature, setShowPharmacistSignature,
        signatureErrors, setSignatureErrors, apiCallMade, setApiCallMade,
        consultation, setConsultation
    } = useCustomStates()

    const [selectedDoses, setSelectedDoses] = useState({})

    const [loadMore, setLoadMore] = useState(false)
    const [showToast, setShowToast] = useState({ successToast: false, errorToast: false })

    const dispatch = Hooks.useCustomDispatch();
    const navigate = Hooks.useCustomNavigate();

    const handleDropdownToggle = (index) => {
        setConsultation(null)
        if (openIndex === index) {
            setOpenIndex(null);
        } else {
            setOpenIndex(index);
        }

        setPharmacistSignature(null)
        setShowPharmacistSignature(false)
        setTimeout(() => {
            const nextPatientCard = document.getElementById(`patientCard-${index}`);
            if (nextPatientCard) {
                nextPatientCard.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100)
        setSignatureErrors(prevState => ({ ...prevState, pharmacistSign: null }))
    }

    useEffect(() => {
        if (pharmacyId) {
            setLoading(true)
            if (!apiCallMade) {
                dispatch(deleteAllPatientList())
                const params = {
                    pharmacy_id: pharmacyId,
                    page: 1,
                    setLoading: setLoading
                }
                dispatch(fetchPatientListWithoutPharmacistSign(params))
                setApiCallMade(true)
            }
        }
        return () => { }
    }, [])

    const fetchMoreData = () => {
        if (PatientListWithoutPharmacistSignResponse?.currentPage < PatientListWithoutPharmacistSignResponse?.totalPages) {
            setLoadMore(true)
            setLoading(false)
            const params = {
                pharmacy_id: pharmacyId,
                page: PatientListWithoutPharmacistSignResponse?.currentPage + 1,
                setLoading: setLoading,
                setLoadMore: setLoadMore
            }
            dispatch(fetchPatientListWithoutPharmacistSign(params))
        }
    }

    const refreshPendingSignatures = () => {
        if (!pharmacyId || PatientListWithoutPharmacistSignResponse?.loading) return

        setOpenIndex(null)
        setPharmacistSignature(null)
        setShowPharmacistSignature(false)
        setLoading(true)
        dispatch(deleteAllPatientList())
        dispatch(fetchPatientListWithoutPharmacistSign({
            pharmacy_id: pharmacyId,
            page: 1,
            setLoading
        }))
    }

    const updatePharmacistSignature = (id, index, patientData) => {

        const flexiDeliveryIDs = patientData?.patient_winrx_data_all
            ?.filter(patient => patient.is_din_matched?.status === 1 && patient.flexi_delivery)
            ?.map(patient => patient.id);

        if (!pharmacistSignature) {
            setSignatureErrors(prevState => ({ ...prevState, pharmacistSign: '1px solid red' }));
        }
        else {
            const requestedData = {
                pharmacy_id: pharmacyId,
                signature: pharmacistSignature,
                patient_id: id,
                setShowToast: setShowToast,
                dispatch: dispatch,
                setLoading: setLoading,
                consultation: consultation,
                flexi_rx_refill_id: flexiDeliveryIDs
            }
            dispatch(filterPatientsByPharmacistSign(id))
            setOpenIndex(null);
            setPharmacistSignature(null)
            setShowPharmacistSignature(false)
            dispatch(UpdatePharmacistSignature(requestedData))
            setSignatureErrors(prevState => ({ ...prevState, pharmacistSign: null }));
            setTimeout(() => {
                const nextIndex = index;
                const nextPatientCard = document.getElementById(`patientCard-${nextIndex}`);
                if (nextPatientCard) {
                    nextPatientCard.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
            setShowToast(prevState => ({ ...prevState, successToast: true }));

            setTimeout(() => {
                setShowToast(prevState => ({ ...prevState, successToast: false }))
            }, 2000);
        }
    }

    const handleScrollSign = (index) => {
        setTimeout(() => {
            const nextPatientCard = document.getElementById(`signature-${index}`);
            if (nextPatientCard) {
                nextPatientCard.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 100)
    }

    return (<React.Fragment>

        {patientList?.length > 0 &&
            <InfiniteScroll
                dataLength={patientList?.length}
                next={fetchMoreData}
                hasMore={PatientListWithoutPharmacistSignResponse?.currentPage <= PatientListWithoutPharmacistSignResponse?.totalPages}
            />
        }

        <div className="app-wrapper flex justify-center">
            <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
                <div className="relative p-4" >
                    <Common.TopBar />
                    <div className="flex gap-3 mb-3">
                        <SearchBox
                            pharmacyId={pharmacyId}
                            onRefresh={refreshPendingSignatures}
                            isRefreshing={PatientListWithoutPharmacistSignResponse?.loading && loading}
                        />
                    </div>


                    <div className="title-row my-2" >
                        <h1 className="text-xl font-bold">Pending Signatures</h1>
                    </div>

                    <div className="routes-list">
                        {(PatientListWithoutPharmacistSignResponse?.loading && loading) ?
                            <div className='flex justify-center h-96'>
                                <Loading.LoadingView />
                            </div> :

                            PatientListWithoutPharmacistSignResponse?.error !== null ?
                                <div className='flex  justify-center pb-4 mb-4'>
                                    <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                                </div> :

                                (patientList?.length === 0 && !PatientListWithoutPharmacistSignResponse?.loading) ?
                                    <p className='flex  justify-center pb-4 pt-3 h-96'>No more pending signatures for today.</p>
                                    :
                                    patientList?.map((data, index) => (
                                        <React.Fragment key={index}>
                                            {data?.patient_winrx_data_all?.length === 0 || data?.patient_winrx_data_all === null ? null :
                                                <div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
                                                    <PatientDetails
                                                        data={data}
                                                        totalRxData={data?.patient_winrx_data_all?.length}
                                                        index={index}
                                                        patientImg={data.profile_image}
                                                        openIndex={openIndex}
                                                        onDropdownToggle={handleDropdownToggle}
                                                    >
                                                        <PendingPharmacistSignRxData rxData={data?.patient_winrx_data_all}
                                                            patientData={data}
                                                            selectedDoses={selectedDoses}
                                                            setSelectedDoses={setSelectedDoses}
                                                        />
                                                        <div className=''>
                                                            <Common.DeliveryConsultationDropdown consultation={consultation} setConsultation={setConsultation} />
                                                        </div>

                                                        <div className='' onClick={() => handleScrollSign(index)} id={`signature-${index}`}>
                                                            <Common.PharmacistSignature
                                                                pharmacistSignature={pharmacistSignature}
                                                                setPharmacistSignature={setPharmacistSignature}
                                                                showPharmacistSignature={showPharmacistSignature}
                                                                setShowPharmacistSignature={setShowPharmacistSignature}
                                                                signatureErrors={signatureErrors}
                                                                setSignatureErrors={setSignatureErrors} />
                                                        </div>

                                                        <button onClick={() => updatePharmacistSignature(data.id, index, data)} className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md w-full">
                                                            Continue
                                                        </button>
                                                    </PatientDetails>
                                                </div>}

                                        </React.Fragment>))}
                    </div>
                </div>

                {loadMore &&
                    <div className='flex mb-2'>
                        <div className="loaderss"></div>
                    </div>}

                {showToast.successToast && <SuccessMessage message='Signature Updated Successfully' setShowToast={() => setShowToast(prevState => ({ ...prevState, successToast: false }))} />}

                {showToast.errorToast && <ErrorMessage message='Oops! Got an issue while updating sign.please try again.' setShowToast={() => setShowToast(prevState => ({ ...prevState, errorToast: false }))} />}

            </div>
        </div>
    </React.Fragment>
    )
}

export default PendingPharmacistSignatures
